import { Pipe, PipeTransform } from '@angular/core';
import Autolinker, { AutolinkerConfig } from 'autolinker';
import { GifPreview, LinkPreview } from "@teammood/timeline";

@Pipe({
    name: 'linky',
    standalone: false
})
export class LinkyPipe implements PipeTransform {
  transform(value: string, options?: AutolinkerConfig): string {
    return Autolinker.link(value, options);
  }
}

@Pipe({
    name: 'removeGifUrls',
    standalone: false
})
export class RemoveGifUrlsPipe implements PipeTransform {
  transform(value: string, linkPreviews: LinkPreview[] | GifPreview[]): string {
    if (!linkPreviews){
      return value;
    } else {
      const withoutLinks =  linkPreviews
          .filter(link => link.url.slice(-4) === ".gif")
          .map(link => link.url)
          .reduce((prev, curr) => {
            return prev.replace(curr, '');
          }, value);
      return withoutLinks;
    }
  }
}